import { useState, useEffect } from "react";

const useInView = (ref) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const currentElement = ref.current; // Capture ref.current in a variable

    if (!currentElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.2 } // Adjust the threshold as needed
    );

    observer.observe(currentElement);

    // Cleanup function
    return () => {
      if (currentElement) {
        observer.unobserve(currentElement); // Use captured variable
      }
      observer.disconnect(); // Disconnect observer
    };
  }, [/* eslint-disable-next-line react-hooks/exhaustive-deps */ ref]); // Use ref.current as a dependency

  return isInView;
};

export default useInView;
